// Pick your starting champion from 3 random options (or all in debug mode).

import type { Scene } from "../engine/scene/SceneManager";
import type { Game } from "../game/Game";
import { CHAMPIONS, TIER_COLORS, type ChampionId } from "../data/champions";
import { championIconUrl } from "../config/constants";
import { RNG, randomSeed } from "../game/RNG";
import { generateAct, DEFAULT_NODE_WEIGHTS } from "../map/MapGenerator";
import { getAct } from "../data/acts";
import { enterNode } from "./NodeRouter";
import { WorldMapScene } from "./WorldMapScene";
import { RECRUIT_POOL } from "./rewards/ChampionRewards";
import { mountAnchor } from "../ui/AdManager";

export class ChampionSelectScene implements Scene {
  private root: HTMLDivElement;
  private offers: ChampionId[];

  constructor(private game: Game) {
    this.root = document.createElement("div");
    this.root.className = "choice-screen";

    const all = Object.keys(CHAMPIONS) as ChampionId[];
    if (game.debug) {
      this.offers = all;
    } else {
      this.offers = ["Garen", "Ahri", "Jinx"];
    }
  }

  enter(): void {
    const subtitle = this.game.debug
      ? '<div style="color:#eab308;font-size:11px;letter-spacing:2px;margin-bottom:12px">DEBUG: ALL CHAMPIONS SHOWN</div>'
      : '<div style="color:var(--text-dim);font-size:11px;letter-spacing:2px;margin-bottom:12px">PICK 1 TO START YOUR RUN</div>';

    this.root.innerHTML = `
      <div class="reward-title">CHOOSE YOUR CHAMPION</div>
      ${subtitle}
      <div class="choice-card-list" id="offers"></div>
    `;
    const list = this.root.querySelector("#offers") as HTMLDivElement;
    for (const id of this.offers) this.addCard(list, id);
    this.game.sceneRoot.appendChild(this.root);
    mountAnchor();
  }

  private addCard(list: HTMLElement, id: ChampionId): void {
    const def = CHAMPIONS[id];
    const tierColor = TIER_COLORS[def.tier];
    const card = document.createElement("div");
    card.className = "choice-card cs-simple";
    card.style.setProperty("--tier", tierColor);
    card.innerHTML = `
      <div class="icon" style="background-image:url('${championIconUrl(def.iconId)}')"></div>
      <div class="title">${def.displayName}</div>
    `;
    card.addEventListener("click", () => this.onPick(id));
    list.appendChild(card);
  }

  private onPick(id: ChampionId): void {
    const state = this.game.runState;
    if (!state) return;
    state.addChampion(id, 660);

    if (!state.map) {
      const act = getAct(state.act);
      const weights = { ...DEFAULT_NODE_WEIGHTS, ...act.nodeWeights };
      state.map = generateAct(state.act, state.seed, weights);
    }
    this.game.sceneManager.transition(new WorldMapScene(this.game));
  }

  exit(): void { this.root.remove(); }
  update(_dt: number): void {}
  render(_ctx: CanvasRenderingContext2D): void {}
}
